import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form';
import { FormInput, FormLabel, FormFeedback } from './form';
import { Button } from './buttons';
import { required, email, composeValidators } from "../helpers/formValidators";
import './Invite.scss';

function Invite({
  isSuccessMessageVisible,
  isEmailDuplicateMessageVisible,
  isResearchIdDuplicateMessageVisible,
  isLoading,
  isButtonDisabled,
  onSubmit,
}) {
  const { t } = useTranslation();

  const title = isSuccessMessageVisible
    ? t('invite.successTitle')
    : t('invite.title');

  return (
    <div>
      <div className="page-header">
        <h3>{title}</h3>
      </div>
      <div className="invite-container container">
        {isSuccessMessageVisible ? (
          <div className="invite-success-message">
            <p>{t('invite.successDescription1')}</p>
            <p>{t('invite.successDescription2')}</p>
          </div>
        ) : (
          /* 2. Wrap in Final Form provider */
          <Form
            onSubmit={onSubmit}
            render={({ handleSubmit, submitting, pristine, invalid }) => (
              <form className="invite" onSubmit={handleSubmit}>
                <p>{t('invite.description')}</p>
                
                <Field
                  name="email"
                  validate={composeValidators(required, email)}
                >
                  {({ input, meta }) => (
                    <>
                      <FormInput
                        {...input}
                        meta={meta}
                        disabled={isLoading || submitting}
                        reject={isEmailDuplicateMessageVisible}
                        labelRenderer={() => (
                          <FormLabel>{t('invite.emailLabel')}</FormLabel>
                        )}
                        placeholder={t('invite.emailPlaceholder')}
                        type="email"
                      />
                      {isEmailDuplicateMessageVisible && (
                        <FormFeedback positive={false}>
                          {t('invite.duplicateEmail')}
                        </FormFeedback>
                      )}
                    </>
                  )}
                </Field>

                <Field
                  name="researchId"
                  validate={required}
                >
                  {({ input, meta }) => (
                    <>
                      <FormInput
                        {...input}
                        meta={meta}
                        disabled={isLoading || submitting}
                        reject={isResearchIdDuplicateMessageVisible}
                        labelRenderer={() => (
                          <FormLabel>{t('invite.researchIdLabel')}</FormLabel>
                        )}
                        placeholder={t('invite.researchIdPlaceholder')}
                      />
                      {isResearchIdDuplicateMessageVisible && (
                        <FormFeedback positive={false}>
                          {t('invite.duplicateResearchId')}
                        </FormFeedback>
                      )}
                    </>
                  )}
                </Field>

                <div className="invite-container__footer">
                  <Button
                    colorScheme="red"
                    label={t('invite.button')}
                    loading={isLoading || submitting}
                    /* 3. Combined legacy disabled logic with Final Form state */
                    disabled={isButtonDisabled || submitting || invalid || pristine}
                    type="submit"
                  />
                </div>
              </form>
            )}
          />
        )}
      </div>
    </div>
  );
}

Invite.propTypes = {
  isEmailDuplicateMessageVisible: PropTypes.bool.isRequired,
  isResearchIdDuplicateMessageVisible: PropTypes.bool.isRequired,
  isSuccessMessageVisible: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isButtonDisabled: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default Invite;
